export default "__VITE_ASSET__BO0lm5hT__"